import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { useApiProgress } from '../../hooks/ApiProgress';
import { toast } from 'react-toastify';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import { OPERATION_PATH, getOperationById, updateOperation } from '../../api/operationApi';
import { updateOperationAction } from '../../redux/feature/operationSlice';

const OperationEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [operation, setOperation] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${OPERATION_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${OPERATION_PATH}`, false)

    useEffect(() => {
        getOperationById(id).then(res => setOperation(res.data))
    }, [id])

    const onClickSubmit = () => {
        updateOperation(id, operation).then(res => {
            dispatch(updateOperationAction(res.data))
            closeTab()
            toast.success('İşlem güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>İşlem Düzenle</label>
                <Input
                    label='İşlem Kodu'
                    name='code'
                    value={operation.code}
                    placeholder='İşlem kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setOperation, setErrors)}
                />
                <Input
                    label='İşlem Adı'
                    name='name'
                    value={operation.name}
                    placeholder='İşlem adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setOperation, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    value={operation.description}
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setOperation, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default OperationEditPage